'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'ESign SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'eSign Basics',
            subtitle: 'Need to eSign a document? Use HelloSign for free.',
            buttonText: 'SIGN UP'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How do I eSign a document?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'When you have a document to sign, it can be uploaded to an eSignature service, such as ',
                _react2['default'].createElement(
                    'a',
                    { href: '/', target: '_blank', rel: 'noopener noreferrer' },
                    'HelloSign'
                ),
                ', to generate a signature. Once the document is eSigned, you can email the document to your intended recipient. eSignatures are a legally accepted and protected form of signature. In the US, they\u2019re covered by the eSign Act.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What is the ESIGN Act?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'The ESIGN Act, otherwise known as Electronic Signatures in Global and National Commerce Act, was signed in 2000 to give eSignatures the same status as written signatures.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Learn more about the ESIGN Act by ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://info.hellosign.com/esignatures-cheat-sheet.html',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'downloading our free eBook: eSignatures 101'
                ),
                '.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What are the benefits of eSigning?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Being able to eSign a document is great for improving workflows. When you eSign a document, you eliminate the need to print the document, sign it, then scan it. Being able to eSign documents streamlines the process for completing paperwork and reduces productivity waste.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Here are some of the other ways eSignatures are beneficial:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Faster turnaround time for completed documents and contracts'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Better security and document tracking'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Low cost'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Eliminate paper waste'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What are the limitations of eSigning?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'There are certain types of documentation that are not covered by the ESIGN Act (for example, adoption and divorce papers). For a list of documents that need to be signed in-person, you can ready about it in our ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'blog post on eSignature legality'
                ),
                '.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How do I use HelloSign to eSign?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Signing a document using HelloSign only takes a few minutes. Here are the steps to eSigning your first document:'
            ),
            _react2['default'].createElement(
                'ol',
                null,
                _react2['default'].createElement(
                    'li',
                    null,
                    'Create a Hellosign account.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Choose who needs to sign (\u201CJust me\u201D, \u201CMe & Others\u201D, or \u201CJust Others\u201D).'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Upload your document.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Sign or add signature fields.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Send off your document to the intended recipient.'
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                'For more detailed instructions, head over to our ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'https://faq.hellosign.com/hc/en-us/categories/200353538-HelloSign-Help',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'Help Center'
                ),
                ' for information on this and other features.'
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get started: eSign a document for free',
            subtitle: 'Want to try eSigning yourself? Create a free account with us (no strings attached, we promise!). Or if you’re looking for more features for your business (for example, team features, in-person signing, or signer access codes), request a demo with one of our eSignature experts.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl,
            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/esign.jsx
 ** module id = 1229
 ** module chunks = 0
 **/